import { ExpandMore } from '@tunasong/icons'
import type { ApprovablePermission } from '@tunasong/schemas'
import {
  Button,
  ButtonGroup,
  Menu,
  MenuContent,
  MenuItem,
  MenuTrigger,
  requestAccessCopy as copy,
} from '@tunasong/ui-lib'
import type { FC } from 'react'
import styles from './access-request-row.module.css'

export interface ApproveSplitButtonProps {
  /** The requester's display name, for accessible names */
  name: string
  disabled: boolean
  onApprove(permission: ApprovablePermission): void
}

/**
 * The main part reads "Approve (can view)" and grants Can view (least privilege); Can edit always takes the
 * explicit menu choice (request-access spec §8.4, §8.9 #7). Same composition as Home's New song split button.
 */
export const ApproveSplitButton: FC<ApproveSplitButtonProps> = props => {
  const { name, disabled, onApprove } = props
  return (
    <ButtonGroup aria-label={`${copy.approve} ${name}`} className={styles.split}>
      <Button
        variant="contained"
        size="small"
        className={styles.action}
        disabled={disabled}
        aria-label={`${copy.approve} ${name}, ${copy.canView.toLowerCase()}`}
        onClick={() => onApprove('READ')}
      >
        {copy.approveCanView}
      </Button>
      <Menu>
        <MenuTrigger
          render={
            <Button
              variant="contained"
              size="small"
              className={styles.action}
              disabled={disabled}
              aria-label={copy.approveAs}
            >
              <ExpandMore />
            </Button>
          }
        />
        <MenuContent>
          <MenuItem onClick={() => onApprove('READ')}>{copy.canView}</MenuItem>
          <MenuItem onClick={() => onApprove('WRITE')}>{copy.canEdit}</MenuItem>
        </MenuContent>
      </Menu>
    </ButtonGroup>
  )
}
